import ChannelEditTitlePage from '../ChannelEdit/ChannelEditTitlePage'

export default ChannelEditTitlePage


// WEBPACK FOOTER //
// ./src/pages/LectureEdit/LectureEditTitlePage.js